export const BASE_URL = import.meta.env.VITE_BASE_URL || 'https://olvidadme.com'
export const SITE_NAME = 'Olvidadme'
export const DEFAULT_IMAGE = `${BASE_URL}/og-image.png`
